var exports = {
  "kL": "ModViewPanel.module__container___enRHaW",
  "uW": "ModViewPanel.module__section___enRHaW",
  "Gf": "ModViewPanel.module__sectionTitle___enRHaW",
  "jf": "ModViewPanel.module__statusRow___enRHaW",
  "Od": "ModViewPanel.module__statusBadge___enRHaW",
  "KZ": "ModViewPanel.module__statusTimedOut___enRHaW",
  "o9": "ModViewPanel.module__statusClean___enRHaW",
  "No": "ModViewPanel.module__durationGrid___enRHaW",
  "jZ": "ModViewPanel.module__durationButton___enRHaW",
  "sX": "ModViewPanel.module__removeTimeoutBtn___enRHaW",
  "zE": "ModViewPanel.module__enforceRow___enRHaW",
  "Dl": "ModViewPanel.module__enforceButton___enRHaW",
  "KT": "ModViewPanel.module__notesList___enRHaW",
  "$6": "ModViewPanel.module__emptyNotes___enRHaW",
  "ND": "ModViewPanel.module__noteCard___enRHaW",
  "YH": "ModViewPanel.module__noteHeader___enRHaW",
  "sS": "ModViewPanel.module__noteAuthor___enRHaW",
  "gA": "ModViewPanel.module__noteText___enRHaW",
  "Mi": "ModViewPanel.module__deleteNoteBtn___enRHaW",
  "nL": "ModViewPanel.module__noteInputRow___enRHaW",
  "Bf": "ModViewPanel.module__noteInput___enRHaW",
  "EF": "ModViewPanel.module__addNoteBtn___enRHaW",
};

module.exports = exports;
